/* "Pairs well with" cards — see snippets/kp-upsell.liquid.
   Each card picks a variant, adds ONE unit with /cart/add.js and stays on the
   page. It never touches the pack button above it. */
(function () {
  function init(box) {
    var dataEl = box.querySelector('[data-up-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var img = box.querySelector('[data-up-img]');
    var price = box.querySelector('[data-up-price]');
    var was = box.querySelector('[data-up-was]');
    var note = box.querySelector('[data-up-note]');
    var btn = box.querySelector('[data-up-add]');
    var optval = box.querySelector('[data-up-optval]');
    var swIdx = parseInt(box.getAttribute('data-up-swidx'), 10);
    if (isNaN(swIdx) || swIdx < 0) swIdx = 0;
    if (!btn || !data.variants || !data.variants.length) return;

    var selected = null;
    for (var k = 0; k < data.variants.length; k++) {
      if (String(data.variants[k].id) === String(data.selected)) { selected = data.variants[k]; break; }
    }
    if (!selected) selected = data.variants[0];
    var picks = selected.options.slice();

    function find() {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var j = 0; j < picks.length; j++) { if (v.options[j] !== picks[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function paint() {
      var v = find();
      var sw = box.querySelectorAll('[data-up-value]');
      for (var i = 0; i < sw.length; i++) {
        var oi = parseInt(sw[i].getAttribute('data-up-opt'), 10) || 0;
        sw[i].classList.toggle('is-on', sw[i].getAttribute('data-up-value') === picks[oi]);
      }
      if (optval) optval.textContent = picks[swIdx] || '';
      box.classList.remove('is-added');
      btn.textContent = '+';
      if (note) note.hidden = true;
      if (!v) { btn.disabled = true; return; }
      selected = v;
      if (img && v.image) img.src = v.image;
      if (price) price.textContent = v.price;
      if (was) { was.textContent = v.compare; was.hidden = !v.compare; }
      btn.disabled = !v.available;
    }

    var sws = box.querySelectorAll('[data-up-value]');
    for (var a = 0; a < sws.length; a++) {
      sws[a].addEventListener('click', function () {
        picks[parseInt(this.getAttribute('data-up-opt'), 10) || 0] = this.getAttribute('data-up-value');
        paint();
      });
    }
    var sels = box.querySelectorAll('select[data-up-opt]');
    for (var b = 0; b < sels.length; b++) {
      sels[b].addEventListener('change', function () {
        picks[parseInt(this.getAttribute('data-up-opt'), 10) || 0] = this.value;
        paint();
      });
    }

    btn.addEventListener('click', function () {
      if (!selected || btn.disabled) return;
      btn.disabled = true;
      btn.textContent = '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          box.classList.add('is-added');
          btn.textContent = '✓';
          btn.disabled = false;
          if (note) note.hidden = false;
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              var els = document.querySelectorAll('[data-cart-count]');
              for (var i = 0; i < els.length; i++) { els[i].textContent = c.item_count; els[i].hidden = !c.item_count; }
            })
            .catch(function () {});
        })
        .catch(function () { btn.disabled = false; btn.textContent = '+'; });
    });
  }

  var boxes = document.querySelectorAll('[data-upsell]');
  for (var i = 0; i < boxes.length; i++) init(boxes[i]);
})();
